export const API_3_MIN = '7.0.0';
export const API_2_MIN = '6.0.0';
export const API_DEFAULT_MIN = '5.9.0';
